module.exports = __webpack_public_path__ + "img/sbl0001.77a5fe14.png";